var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ResearchGalleryPage',{attrs:{"page-title":"论文答辩","section-label":"研究生教育","section-route":_vm.sectionRoute,"top-strip-image":_vm.topStripImage,"hero-background-image":_vm.heroBackgroundImage,"groups":_vm.groups}})
}
var staticRenderFns = []

export { render, staticRenderFns }